import { render, staticRenderFns } from "./PerformanceGraph.vue?vue&type=template&id=a32cf86a&"
import script from "./PerformanceGraph.vue?vue&type=script&lang=js&"
export * from "./PerformanceGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports